import React from 'react';
import PropTypes from 'prop-types';

import UserAvatar from '../../../components/UserAvatar';

import RightArrow from '../../../assets/images/arrow-button.svg';
import SpeakerIcon from '../../../assets/images/speaker.svg';
import EmailIcon from '../../../assets/images/email-icon-gray.svg';

import './MobileUserCard.scss';

MobileUserCard.propTypes = {
  // Click handler for the component
  handleCardClick: PropTypes.func, 
  online: PropTypes.bool,
  // If no title is given, user.title will be used
  title: PropTypes.string,
  user: PropTypes.object.isRequired,
};
export default function MobileUserCard(props) {

  function handleCardClick() {
    props.handleCardClick(props.user);
  }

  const user = props.user || {};

  return (
    <div className={'mobile-user-card' + (props.fromPopup ? ' from-popup' : '')} onClick={handleCardClick}>
        <UserAvatar user={user} large={true}/>
        <div className={'mobile-user-card__user-info'+ (props.fromPopup ? ' from-popup' : '')}>
          <span className="title-and-name"> {((props.title || user.title || '') + ' | ').toUpperCase() + user.first_name+' '+user.last_name} </span>
          <span className="email">
            <img src={EmailIcon} alt="email"/>
            &nbsp;
            <p>{user.email || 'No Email'}</p>
          </span>
          <span className="phone">
            <img src={SpeakerIcon} alt="phone"/>
            &nbsp;
            <p>{user.phone || 'No Phone'}</p>
          </span>
        </div>
        {
          props.online && !props.fromPopup &&
          <img className="mobile-user-card__arrow" src={RightArrow} alt="right arrow"/>
        }
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/ProjectDetailsContainer/MobileUserCard/index.js